import { UTM_BUILDER_DEFAULTS } from '../../config/utmBuilderDefaults'
import applyMediumRules from './applyMediumRules'

const EXPLICITLY_INVALID_PAIRS = new Set([
  'google:story',
  'google:post',
  'google:reel',
  'google:profile',
  'google:banner_ad',
  'google:partner_post',
  'google:email',
  'google:other',
  'email:story',
  'email:reel',
  'email:ad',
  'email:profile',
  'email:post',
  'email:banner_ad',
  'email:partner_post',
  'email:other',
  'partner:story',
  'partner:reel',
  'partner:ad',
  'partner:profile',
  'partner:email',
  'partner:other',
  'instagram:email',
  'facebook:email',
  'telegram:email',
  'viber:profile',
  'viber:story',
  'viber:post',
  'viber:reel',
  'viber:ad',
  'viber:banner_ad',
  'viber:email',
  'viber:partner_post',
  'viber:other',
  'instagram:broadcast',
  'facebook:broadcast',
  'telegram:broadcast',
  'google:broadcast',
  'email:broadcast',
  'partner:broadcast',
  'other:broadcast',
])

const hasMediumRule = (channel, format, mediumRules = []) =>
  mediumRules.some(({ channel: ruleChannel, formats }) => ruleChannel === channel && formats.includes(format))

/**
 * Validate channel + format for UTM generation.
 * Invalid combinations must not produce misleading medium/campaign values.
 */
export const validateUtmChannelFormat = ({
  channel,
  format,
  config = UTM_BUILDER_DEFAULTS,
}) => {
  if (!channel || !format) {
    return { valid: true, warnings: [] }
  }

  const pairKey = `${channel}:${format}`

  if (EXPLICITLY_INVALID_PAIRS.has(pairKey)) {
    return {
      valid: false,
      warning: 'Невірна комбінація каналу та формату. UTM не згенеровано.',
    }
  }

  if (!hasMediumRule(channel, format, config.mediumRules)) {
    return {
      valid: false,
      warning: 'Ця комбінація каналу та формату не підтримується для UTM.',
    }
  }

  if (channel === 'other' && format === 'other') {
    return {
      valid: true,
      warnings: ['Загальна комбінація other/other. Перевірте коректність перед публікацією.'],
    }
  }

  return { valid: true, warnings: [] }
}

export const resolveUtmMedium = ({ channel, format, config = UTM_BUILDER_DEFAULTS }) => {
  const validation = validateUtmChannelFormat({ channel, format, config })

  if (!validation.valid) {
    return ''
  }

  return applyMediumRules({
    channel,
    format,
    mediumRules: config.mediumRules,
    mediumDefault: config.mediumDefault,
  })
}

export default resolveUtmMedium
